<template>
    <li>
        <a href="#">{{text}}</a>
    </li>
</template>

<script>
export default {
  props: ['text','route'],
}
</script>

<style lang="scss" scoped>
.Invoice_table_popup.active .popup_content a {
    color: #55616E;
    font-size: 16px;
    line-height: 20px;
    text-decoration: none;
    font-family: "Helvetica Neue";
    padding: 10px 15px;
    display: inline-block; 
}

</style>

